/**
 * HTTP layer for a site group's sectioned settings document. The odl_app
 * site-group-settings read/write surface.
 *
 * Contains:
 * - fetchSiteGroupSettings: read a site group's settings sections
 * - patchSiteGroupSettings: write a site group's settings sections
 */
import apiClient from '@sophocles/http-common';

// Consolidated site-group-settings endpoint.  Companion to the
// site-settings endpoint (see `pliny.odl_app.views.site_group_settings`
// for the backend).  Replaces the scattered surface of legacy
// per-tab patch endpoints with a single sectioned payload — both V2
// settings and the upcoming quick-edit dialog read/write through it.
const path = siteGroupId => `odl-app/site-group-settings/${siteGroupId}/`;

export const fetchSiteGroupSettings = siteGroupId => apiClient.get(path(siteGroupId)).then(res => res.data);

export const patchSiteGroupSettings = (siteGroupId, payload) =>
  apiClient.patch(path(siteGroupId), payload).then(res => res.data);
